import styled from "styled-components"

const PopUp = styled.div`
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: ${({theme}) => theme.colors.utility.white};
  box-shadow: ${({theme}) => theme.shadows.above.low};
`

export default PopUp
